import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { portfolioConfig } from 'components/Dashboards/Portfolio/portfolioConfig';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { useFullStoryPageView } from 'hooks/useFullstoryPageView';
import { MainContent } from 'components/common/PageContainer/MainContent';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { TitleSection } from 'components/common/PageContainer/titleSection';
import { AddTemplate } from 'components/Dashboards/Portfolio/phasePerformance/manage/components/addTemplate';

export const PhasePerformanceManageAddTemplatePage = () => {
    useFullStoryPageView({ pageName: portfolioConfig.phasePerformanceManageAddTemplate.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <TitleSection>
                        <ProgramTopHeader
                            pageTitle={portfolioConfig.phasePerformanceManageAddTemplate.title}
                            showBack={true}
                        />
                    </TitleSection>
                </VersionWrapper>
            </HeaderWrapper>
            <MainContent>
                <AddTemplate />
            </MainContent>
        </PageContainer>
    );
};
